import { render, staticRenderFns } from "./ViewAssignKpi.vue?vue&type=template&id=66dc38fe&scoped=true&"
import script from "./ViewAssignKpi.vue?vue&type=script&lang=js&"
export * from "./ViewAssignKpi.vue?vue&type=script&lang=js&"
import style0 from "./ViewAssignKpi.vue?vue&type=style&index=0&id=66dc38fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc38fe",
  null
  
)

export default component.exports